// Libraries
var React = require('react');

// Components
var NotificationsIcon = require('./NotificationsIcon');
var NotificationsCenter = require('./NotificationsCenter');

// Styles
require('./NotificationsModule.scss');

class NotificationsModule extends React.Component {
	render() {
		return (
			<div className="Notifications">
				<NotificationsIcon />
				<NotificationsCenter />
			</div>
		)
	}
}

module.exports = NotificationsModule;


// WEBPACK FOOTER //
// ./src/components/Notifications/NotificationsModule.js